import React, { useEffect, useState } from "react"
import { Card, Col, Container, Modal, Row } from "react-bootstrap"

import { useTranslation } from "react-i18next"

import API from "../../common/API"

import Pagination from "../../components/core/Pagination"
import VerificarAntecedentesFilterFields from "../../components/CheckProfile/VerificarAntecedentes.filterFields"
import EmployeDTO from "../../components/Employees/EmployeDTO"
import ActionBar from "../../components/core/ActionBar"
import Filter from "../../components/core/Filter/Filter"
import VerificarAntecedentesListView from "../../components/CheckProfile/Nacionals/VerificarAntecedentesListView"
import VerificarAntecedentesCardView from "../../components/CheckProfile/Nacionals/VerificarAntecedentesCardView"
import Navbar from "../../components/Common/Navbar"


const BackgroundCheckPage = props => {
    // PROPERTIES

    const [viewMode, setViewMode] = useState<"list" | "grid">("list")
    const [page, setPage] = useState(0)
    const [quantity, setQuantity] = useState(20)
    const [totalPages, setTotalPages] = useState(1)

    const [consentUploaded, setConsentUploaded] = useState<boolean>(false)
    const [records, setRecords] = useState<any>([])
    const [filterValues, setFilterValues] = useState<any>({})

    const [filterFields, setFilterFields] = useState(
        VerificarAntecedentesFilterFields
    )
    const getFilterValues = obj => {
        setFilterValues(obj)
    }
    const { t } = useTranslation("global")

    const [isLoading, setIsLoading] = useState(false)


    // METHODS

    const onPageChanged = (obj: number) => {
        setPage(obj)
    }
    const handleFileChange = async e => {
        const file = e.target.files[0]
        if (file) {
            setConsentUploaded(true)
        }
    }
    const bindDataRemote = async () => {
        try {
            setIsLoading(true)

            if (Object.keys(filterValues).length === 0) {
                return
            }

            // Check search type

            let query = ""

            Object.keys(filterValues).forEach(key => {
                query += "&" + key + "=" + filterValues[key]
            })

            query += "&page=" + page + "&quantity=" + quantity
            setIsLoading(true)
            let routePath = "busqueda/nacionales" + "?" + query
            let request = await API.getAction(routePath)
            console.log(request)
            if (request.data.status === "ok") {
                setRecords(request.data.response)
                setTotalPages(request.data.quantityOfPages)
                // setPage(request.data.page)
            }

        } catch (e) {
            console.error(e)
        } finally {
            setIsLoading(false)
        }
    }
    // EVENTS
    useEffect(() => {
        bindDataRemote()
    }, [page])


    useEffect(() => {
        if (filterValues) {
            setPage(0)
            setTimeout(() => {
                bindDataRemote()
            }, 500)
        }
    }, [filterValues])

    document.title = window.location.href.includes("backgroundcheck")
        ? "Background Check"
        : "Data Worker"

    return (
        <Container className="my-4">
            <Navbar></Navbar>
            <ActionBar
                title={window.location.href.includes("backgroundcheck") ? t("Informe de Antecedentes") : t("Verificación y Recomendación de Postulantes")}
                actions={
                    <>
                        <div className="ms-2 btn-group">
                            <button
                                onClick={() => setViewMode("grid")}
                                className={
                                    "btn btn-sm " +
                                    (viewMode === "grid" ? "btn-primary" : "btn-secondary")
                                }
                            >
                                Tarjeta
                            </button>
                            <button
                                onClick={() => setViewMode("list")}
                                className={
                                    "btn btn-sm " +
                                    (viewMode === "list" ? "btn-primary" : "btn-secondary")
                                }
                            >
                                Lista
                            </button>
                        </div>
                    </>
                }
            ></ActionBar>

            <div className="my-4">

                {!consentUploaded ? (
                    <Card className="mb-4 mx-auto">
                        <Card.Header>
                            <Card.Title>{t("Cargar Consentimiento")}</Card.Title>
                        </Card.Header>
                        <Card.Body className="p-0 pt-2">
                            <Row>
                                <Col>
                                    <input
                                        type="file"
                                        onChange={handleFileChange}
                                        className="form-control"
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                        <Card.Footer className="text-end">
                            <button
                                className="btn btn-primary "
                                onClick={() => setConsentUploaded(true)}
                            >
                                Cargar Consentimiento
                            </button>
                        </Card.Footer>
                    </Card>
                ) : (
                    <Filter
                        // toggleFilter={toggleFilter}
                        title={t("Verificar Por:")}
                        fields={filterFields}
                        setFilterFields={getFilterValues}
                        filterAction={() => {
                            console.log("filter")

                            bindDataRemote()
                        }}
                    />
                )}
            </div>
            {isLoading && (
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            {viewMode === "list" ? (

                <VerificarAntecedentesListView
                    records={records}
                    backgroundCheck={true}
                    isLoading={isLoading}
                />

            ) : viewMode === "grid" ? (

                <VerificarAntecedentesCardView
                    records={records}
                    backgroundCheck={true}
                    isLoading={isLoading}
                />

            ) : null}
            <Card className="mb-4">
                <Card.Body className="p-0 pt-2">
                    <Pagination
                        totalPages={totalPages}
                        currentPage={page}
                        onPageChanged={onPageChanged}
                    />
                </Card.Body>
            </Card>
        </Container>
    )
}

export default BackgroundCheckPage
